import '../../sass/layout/sections/info-banner-carousel.scss';

import Swiper, {
    Navigation,
    Autoplay,
    EffectFade
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';

const infoBannerCarousel = document.getElementById('infoBannerCarousel');

if (infoBannerCarousel) {
    const prevEl = infoBannerCarousel.querySelector('.swiper-button-prev');
    const nextEl = infoBannerCarousel.querySelector('.swiper-button-next');

    const options = {
        modules: [Navigation, Autoplay, EffectFade],
        loop: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl,
            nextEl,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        init: true,
    }

    const swiper = new Swiper(infoBannerCarousel, options);

    swiper.on('slideChange', function (swiper) {
        myLazyLoad.update();
    });
    
}